import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class TouchbackFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.TouchBack;
    }

    getRawFragment(play, serializationContext, touchBack) {
        const { code } = touchBack;

        return `${code}:`;
    }
}
